import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationElectronicStorage = createCrudVuexModule({
  namespaced: true,
  path: "/electronic-storage",
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/electronic-storage/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
